import React from "react";
import PropTypes from "prop-types";
import DefaultPropTypes from "../utils/prop-types";
import MimeType from "../utils/mime-type";
import ItemDetailView from "./item-detail-view";
import { trackDownloadInResourceCenter, trackFAQQuestionClick } from "../../../../js/feature/gtm-tracking";
var ListItemView = function ListItemView(_ref) {
  var dictionary = _ref.dictionary,
    item = _ref.item,
    isFAQ = _ref.isFAQ,
    isSearchAndFAQ = _ref.isSearchAndFAQ,
    onClose = _ref.onClose,
    onItemClick = _ref.onItemClick,
    selectedItem = _ref.selectedItem,
    selectedFilters = _ref.selectedFilters;
  var fileTypes = {
    default: "e866",
    pdf: "e620",
    img: "e89c",
    video: "e8a0",
    embed: "e8a0",
    external: "ea41"
  };
  var fileType = item.mimeType.split("/").slice(1)[0];
  var detailViewOn = selectedItem !== null && item.id === selectedItem.id;
  var addTracking = function addTracking() {
    if (!isFAQ && item.mimeType === MimeType.EMBED) {
      trackDownloadInResourceCenter("video embed", item.name, selectedFilters);
    }
    if (isSearchAndFAQ) {
      trackFAQQuestionClick(item.name, item.id);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "file-link ".concat(item.shouldDownload() && " file-download-directly", " ").concat(item.locked && "file-locked"),
    id: item.id,
    rel: "noopener noreferrer",
    target: "_blank",
    href: item.mimeType === MimeType.EMBED ? "" : item.url,
    "aria-expanded": detailViewOn,
    "aria-controls": "detail-".concat(item.id),
    onClick: function onClick(e) {
      onItemClick.apply(null, [e, item]);
      addTracking();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "content-type-icon ".concat(fileType),
    dangerouslySetInnerHTML: {
      __html: "&#x".concat(fileTypes[fileType], ";")
    }
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: item.name
    }
  })), detailViewOn && /*#__PURE__*/React.createElement(ItemDetailView, {
    dictionary: dictionary,
    fileType: fileType,
    isFAQ: isFAQ,
    onClose: onClose,
    selectedItem: selectedItem,
    selectedFilters: selectedFilters
  }));
};
ListItemView.propTypes = {
  onItemClick: PropTypes.func.isRequired,
  item: DefaultPropTypes.item.isRequired,
  selectedItem: DefaultPropTypes.item,
  dictionary: DefaultPropTypes.dictionary.isRequired,
  onClose: PropTypes.func.isRequired
};
ListItemView.defaultProps = {
  selectedItem: null,
  isDesktop: false
};
export default ListItemView;